import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const EtpStpUpgradation: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-revamp' title="ETP/STP Upgradation" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">ETP/STP Upgradation</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Industrial and municipal wastewater treatment plants often face the challenge of increased effluent loads, outdated technology, and changing discharge norms. At Wasser Technochem (I) Ltd., we offer tailored upgradation solutions for ETPs and STPs, ensuring improved efficiency, higher treatment capacity, and full compliance with CPCB/SPCB regulations.</p>
              <p>Our solutions focus on modular integration, energy efficiency, and reuse-oriented design, enabling industries and ULBs to meet rising environmental expectations without full plant replacement.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-search text-primary me-2"></i>Performance audits and root-cause analysis of underperforming plants</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-layer-group text-primary me-2"></i>Integration of advanced treatment stages: tertiary filtration, disinfection, polishing</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-cogs text-primary me-2"></i>Technology upgrades: MBBR to MBR, SBR modifications, sludge handling systems</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-wrench text-primary me-2"></i>Equipment retrofitting: blowers, decanters, diffusers, control panels</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-plus text-primary me-2"></i>Addition of equalization tanks, aeration systems, and clarifiers</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-chart-line text-primary me-2"></i>Hydraulic and process redesign for increased flow or organic load</p>
                </div>
                <div className="col-md-12">
                  <p><i className="fa fa-graduation-cap text-primary me-2"></i>Operator training, documentation, and automation upgrades</p>
                </div>
              </div>

              <h3 className="mb-4">Common Upgrade Elements</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-recycle text-primary me-2"></i>Clarifier & Aeration</h5>
                      <p>Clarifier and aeration tank redesign</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-exchange-alt text-primary me-2"></i>Technology Conversion</h5>
                      <p>Conversion from extended aeration to MBBR or MBR</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-filter text-primary me-2"></i>Tertiary Treatment</h5>
                      <p>Addition of tertiary sand filters and UV/ozone disinfection</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-compress text-primary me-2"></i>Sludge Dewatering</h5>
                      <p>Sludge dewatering press replacement</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-tachometer-alt text-primary me-2"></i>Real-time Monitoring</h5>
                      <p>Real-time analyzers for BOD/COD, MLSS, pH</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Compliance Achievement</h5>
                  <p>Achieve consistent compliance with discharge norms</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Energy Reduction</h5>
                  <p>Reduce energy consumption and chemical usage</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Improved Automation</h5>
                  <p>Improve plant automation and monitoring</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Reduced Issues</h5>
                  <p>Minimize sludge generation and odor issues</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Water Reuse</h5>
                  <p>Enable treated water reuse and cost savings</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-chart-bar text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Proven Success</h5>
                      <p className="mb-0">Successful upgrades of industrial and municipal STPs across India</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-medal text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Track Record</h5>
                      <p className="mb-0">Proven track record with ULBs, CETPs, and Smart City projects</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-project-diagram text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Integrated Services</h5>
                      <p className="mb-0">Integrated services: design, procurement, execution, and revalidation</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-puzzle-piece text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Infrastructure Compatible</h5>
                      <p className="mb-0">Compatible with existing infrastructure and phased expansion</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-bullseye text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Customized Approach</h5>
                      <p className="mb-0">Customized approach based on effluent quality, load, and end-use goals</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default EtpStpUpgradation;
